package br.com.texeratx.boardgametimeapp.ui.screens.expansions.list

data class ExpansionsUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val groups: List<ExpansionGroupUi> = emptyList()
)

data class ExpansionGroupUi(
    val gameId: Long,
    val gameName: String,
    val items: List<ExpansionItemUi>
)

data class ExpansionItemUi(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val bggUrl: String?
)
